import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8a57f5d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Наименование рекламного кабинета", -1))
const _hoisted_5 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Площадка", -1))
const _hoisted_7 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Логин", -1))
const _hoisted_9 = { class: "flex flex-col fl-1 m-b-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "external_id",
  class: "small-label"
}, "Внешний id", -1))
const _hoisted_11 = { class: "flex flex-col fl-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Токен", -1))
const _hoisted_13 = { class: "flex m-t-18 m-b-8" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "updated",
  class: "m-r-20"
}, "Собирать статистику", -1))
const _hoisted_15 = { class: "flex m-t-18 m-b-8" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "naming",
  class: "m-r-20"
}, "Отслеживать корректность написания имени кампании", -1))
const _hoisted_17 = { class: "flex m-t-18 m-b-8" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "use_in_ui",
  class: "m-r-20"
}, "Использовать в UI", -1))
const _hoisted_19 = { class: "flex flex-col fl-1 m-t-18" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "settings",
  class: "small-label"
}, "Settings (JSON)", -1))

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAdsCabinetsStore } from "@/store/dictionaries/ads_cabinets";

import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import {
  areAdsCabinetFieldsValid,
  mapAdsCabinetFromServerToForm,
} from "@/services/dictionaries/ads_cabinets";
import InputSwitch from "primevue/inputswitch";
import SceletonInput from "@/shared/forms/SceletonInput.vue";

import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsCabinetCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = useAdsCabinetsStore();

const adsCabinet = ref({
  name: "",
  source_slug: null as string | null,
  login: "",
  external_id: null as string | null,
  is_statistics_required: true,
  is_naming_checked: true,
  token: "",
  use_in_ui: true,
  settings: null as string | null,
});

const isInvalidForm = ref(false);
const isAdsCabinetSetted = computed(() => {
  return Boolean(route.params.id);
});
const isLoadingData = ref(false);

const reload = () => {
  if (isAdsCabinetSetted.value) {
    const adsCabinetId = parseInt(
      Array.isArray(route.params.id) ? route.params.id[0] : route.params.id
    );
    isLoadingData.value = true;
    store
      .getAdsCabinet(adsCabinetId)
      .then((adsCabinetClone) => {
        if (adsCabinetClone) {
          Object.assign(
            adsCabinet.value,
            mapAdsCabinetFromServerToForm(adsCabinetClone)
          );
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const createAdsCabinet = () => {
  if (!areAdsCabinetFieldsValid(adsCabinet.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`
    );
    return;
  }

  if (adsCabinet.value.settings && adsCabinet.value.settings.trim() !== "") {
    try {
      JSON.parse(adsCabinet.value.settings);
    } catch (e) {
      isInvalidForm.value = true;
      rootGetters.toast.show(
        "warn",
        "Ошибка сохранения",
        `Поле Settings должно содержать валидный JSON.`
      );
      return;
    }
  }

  emit("setLoading", true);
  if (!isAdsCabinetSetted.value) {
    performAdsCabinetAction(() => store.createAdsCabinet(adsCabinet.value));
  } else {
    const adsCabinetCopy = { ...adsCabinet.value };
    if (adsCabinet.value.token == "************") {
      delete (adsCabinetCopy as any).token;
    }
    performAdsCabinetAction(() =>
      store.updateAdsCabinet(
        adsCabinetCopy,
        parseInt(
          Array.isArray(route.params.id) ? route.params.id[0] : route.params.id
        )
      )
    );
  }
};

const performAdsCabinetAction = (action: any) => {
  const handleSuccess = () => {
    router.push({ name: "adsCabinets" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

const handleFocus = () => {
  if (adsCabinet.value.token == "************") {
    adsCabinet.value.token = "";
  }
};

__expose({
  createAdsCabinet,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              id: "name",
              placeholder: "Введите значение",
              modelValue: adsCabinet.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((adsCabinet.value.name) = $event)),
              invalid: isInvalidForm.value && adsCabinet.value.name == ''
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(CatalogDataSingleInput, {
              selectType: "source",
              useIdOnly: true,
              "is-invalid": isInvalidForm.value && adsCabinet.value.source_slug == null,
              isSegmentSetted: false,
              modelValue: adsCabinet.value.source_slug,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (adsCabinet.value.source_slug = $event))
            }, null, 8, ["is-invalid", "modelValue"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              id: "name",
              placeholder: "Введите значение",
              modelValue: adsCabinet.value.login,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((adsCabinet.value.login) = $event)),
              invalid: isInvalidForm.value && adsCabinet.value.login == ''
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              id: "external_id",
              placeholder: "Введите значение",
              modelValue: adsCabinet.value.external_id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((adsCabinet.value.external_id) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              onFocus: handleFocus,
              id: "name",
              placeholder: "Введите значение",
              modelValue: adsCabinet.value.token,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((adsCabinet.value.token) = $event)),
              invalid: isInvalidForm.value && adsCabinet.value.token == ''
            }, null, 8, ["modelValue", "invalid"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_unref(InputSwitch), {
          modelValue: adsCabinet.value.is_statistics_required,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((adsCabinet.value.is_statistics_required) = $event)),
          inputId: "updated"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_unref(InputSwitch), {
          modelValue: adsCabinet.value.is_naming_checked,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((adsCabinet.value.is_naming_checked) = $event)),
          inputId: "naming"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_unref(InputSwitch), {
          modelValue: adsCabinet.value.use_in_ui,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((adsCabinet.value.use_in_ui) = $event)),
          inputId: "use_in_ui"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(Textarea), {
              id: "settings",
              modelValue: adsCabinet.value.settings,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((adsCabinet.value.settings) = $event)),
              placeholder: "Введите JSON, например: {\"key\": \"value\"}",
              autoResize: "",
              rows: "5",
              cols: "30"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ])
    ])
  ]))
}
}

})